import { Component, OnInit } from '@angular/core';
import { ApsServiceService } from 'src/app/aps-service.service';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Params, Router } from '@angular/router';

@Component({
    selector: 'redirect',
    templateUrl: './paymentloader.html',})
export class Paymentsub implements OnInit {
  loaderdata:any=true
  getname:any=localStorage.getItem('FirstName') + " "+localStorage.getItem('LastName')
  userid:any = localStorage.getItem('userid');
  useremail:any=""
  Firstname:any=" "
  lastname:any=" "
  email:any=" "
  phone:any=" "
  address1:any=" "
  address2:any=" "
  zip:any=" "
  city:any=" "
  state:any=" "
  country:any=" "
  sub:any;
  getdatasub:any;
  rate_other:any='00';
  rate_usa:any='00';
  rate_canada:any='00';
  userdata:any;
  currentfull:any;
  checkpaymentstatus: any;

  constructor(private searchitem:ApsServiceService, private toastr: ToastrService,private router: Router,private activatedRoute: ActivatedRoute) { }

  ngOnInit(): void {
    this.getparams()
  }



//   setUserPayment(){
//     var planamount=localStorage.getItem('planamount');
//     var planyear=localStorage.getItem('planyear');
//     var planname=localStorage.getItem('planname');
//     var userid=localStorage.getItem('userid');
//     var donation=localStorage.getItem('Donation');
//     var total=parseFloat(planamount) + parseFloat(donation)

//     var payloader=[]
  
  
//       var dataset={}
//       dataset["name"]=planname
//       dataset["sku"]=1
//       dataset["price"]= total
//       dataset["currency"]="USD"
//       dataset["quantity"]=1
//       payloader.push(dataset)
    
//     var itemss=parseFloat(localStorage.getItem("totalCart"));
//     localStorage.setItem('storedcart',JSON.stringify(payloader))
    
//     var payments={
//       "currency": "USD",
//       "total": total
//     }

    
//     //console.log(payments)
//     //   [{
//     //     "name": "Red Sox Hat",
//     //     "sku": "001",
//     //     "price": "5.00",
//     //     "currency": "USD",
//     //     "quantity": 1
//     // }]
//     //console.log(payloader)
//       this.searchitem.regPayment(payments,payloader).subscribe((responce)=>{
//       //console.log(responce.data)
//       this.loaderdata=false
//       window.location.href=responce.data;
    
//       // this.routerItem.navigate([responce.data])
      
    
//       })
//   }




  getparams(){
 
    if( this.activatedRoute.snapshot.params.payment){
    this.checkpaymentstatus = this.activatedRoute.snapshot.params.payment;
    //console.log(this.activatedRoute.snapshot.params)
    //console.log(this.checkpaymentstatus)
    var planamount=localStorage.getItem('planamount');
    var donation=localStorage.getItem('Donation');
    var total=parseFloat(planamount) + parseFloat(donation)
    if(this.checkpaymentstatus=="success"){
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      //console.log(params);
      
      var itemss=parseFloat(localStorage.getItem("totalsub"));
var payments={
  "currency": "USD",
  "total": itemss
}

this.searchitem.paymentSuccessreg(payments,params).subscribe((responce) => {
  if(responce.status){

    //console.log(responce)
//    this.toastr.success("payment success")
    this.addSubscription()


}else{
    this.toastr.error('please try again','error')   
    this.router.navigate(['/userpage']) 

}

})
      
    });



  }else     if(this.checkpaymentstatus=="cancel"){
  
    this.toastr.error('please try again','error')   
    this.router.navigate(['/userpage'])
  }
}


  }

  logout() {
    localStorage.clear();
    this.router.navigate(["/"]).then(() => {
      window.location.reload();
      this.toastr.success('', 'Subscription Successfully Complected')
    });
  }




  addSubscription(){
      var  userdata =localStorage.getItem("addsub")
   userdata= JSON.parse(userdata)
    //console.log(userdata)
      this.searchitem.subscription(userdata).subscribe((responce) => {
  //console.log(responce);
  if(responce.status){
    this.toastr.success('', 'Subscription Successfully Complected')
    this.router.navigate(['/userpage'])
    // this.loaderdata=false;
    this.logout()


    
  }else{
    this.toastr.error('please try again','error')    
    this.router.navigate(['/userpage'])
    // this.loaderdata=false;


  }
    })
  }



}
